export const REFERRAL_USER_ROLE = {
  PARTNER: 'REFERRAL_PARTNER',
  MANAGER: 'REFERRAL_MANAGER',
  FOUNDER: 'REFERRAL_FOUNDER',
  ADMIN: 'REFERRAL_ADMIN',
} as const;

export type ReferralUserRoleType = (typeof REFERRAL_USER_ROLE)[keyof typeof REFERRAL_USER_ROLE];
